(function (angular) {
    "use strict";
    var fmgApp = angular.module('FmgProduceSuite-Launcher');

    fmgApp.config(function ($urlRouterProvider) {
        // Here's an example of how you might allow case insensitive urls
        // Note that this is an example, and you may also use
        // $urlMatcherFactory.caseInsensitive(true); for a similar result.
        $urlRouterProvider.rule(function ($injector, $location) {
            //what this function returns will be set as the $location.url
            var path = $location.path(), normalized = path.toLowerCase();
            if (path != normalized) {
                //instead of returning a new url string, I'll just change the $location.path directly so I don't have to worry about constructing a new url string and so a new state change is not triggered
                $location.replace().path(normalized);
            }
            // because we've returned nothing, no state change occurs
        });
    });

    fmgApp.config(['$stateProvider', '$urlMatcherFactoryProvider', function ($stateProvider, $urlMatcherFactoryProvider) {

        $urlMatcherFactoryProvider.strictMode(false);
        //$urlMatcherFactory.caseInsensitive(true);

        $stateProvider.state('default', {
                url: "",
                views: {
                    'primary': {
                        templateUrl: 'launcher-app/parts/_login.html',
                        controller: 'LoginController'
                    }
                }
            }).state('set', {
            url: "/set?code",
            views: {
                'primary': {
                    templateUrl: 'launcher-app/parts/_setPassword.html',
                    controller: 'SetPasswordController'
                }
            }
        }).state('list', {
            url: "/list",
            views: {
                'primary': {
                    templateUrl: 'launcher-app/parts/_products.html',
                    controller: 'ProductsController'
                }
            }
        }).state('connectionTest', {
            url: "/testmyconnection",
            views: {
                'primary': {
                    templateUrl: 'launcher-app/parts/_connectionTest.html',
                    controller: 'ConnectionTestController'
                }
            }
        }).state('forgotPassword', {
            url: "/forgotpassword",
            views: {
                'primary': {
                    templateUrl: 'launcher-app/parts/_forgotPassword.html',
                    controller: 'PasswordRecoveryController'
                }
            }
        }).state('forgotPasswordCode', {
            url: "/forgotpassword/code?code",
            views: {
                'primary': {
                    templateUrl: 'launcher-app/parts/_setPassword.html',
                    controller: 'SetPasswordController'
                }
            }
        }).state('handoff', {
            url: "/handoff?tkn",
            views: {
                'primary': {
                    templateUrl: 'launcher-app/parts/_handoff.html',
                    controller: 'HandoffController'
                }
            }
        });
    }]);



})(window.angular);


